<div
    class="container"
    [class.white]="whiteMode"
    [style]="{
        top: y + 'px',
        left: x + 'px',
    }">
    <div class="main">
        <div
            #componentsContainer
            class="component-container"
            data-cy="mimics-library-component-list"
            [class.white]="whiteMode"
            [class.in-dialog]="isSettingCondition">
            <div
                class="component"
                [class.white]="whiteMode"
                [class.select]="selectedComponent?.id === component.id"
                *ngFor="let component of componentList; let i = index"
                (click)="addToCanvas($event, component); $event.stopPropagation()"
                (contextmenu)="openComponentOptions($event, component)">
                <svg
                    #svgHost
                    width="80"
                    height="80"
                    viewBox="0 0 1200 900"
                    preserveAspectRatio="xMidYMid meet"
                    style="border: solid 1px #516174; background-color: #2c3a48; pointer-events: none"></svg>
                <div class="component-name" data-cy="mimics-library-component-name" [class.white]="whiteMode">
                    {{ component.name }}
                </div>
                <ng-container *ngIf="showComponentOption">
                    <div
                        class="more-options-container"
                        [style.top]="optionsTop"
                        [style.left]="optionsLeft"
                        [style.display]="selectedComponent == component ? 'flex' : 'none'"
                        (click)="$event.stopPropagation()">
                        <button type="button" class="button" (click)="addToCanvas($event, component)">
                            {{ 'editor.library.option.add-to-canvas' | translate }}
                        </button>
                        <button type="button" class="button">
                            {{ 'mimic.page.button.edit' | translate }}
                        </button>
                        <button type="button" class="button" (click)="deleteComponent()">
                            {{ 'mimic.page.button.delete' | translate }}
                        </button>
                        <button type="button" class="button" (click)="duplicateComponent()">
                            {{ 'mimic.page.button.duplicate' | translate }}
                        </button>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
